
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity-verification",
      function () {
        return require("private-next-pages/docs/identity-verification/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity-verification"])
      });
    }
  